import { useTranslation } from 'react-i18next';

import { SCHOOL_LOGO_MAX_HEIGHT } from 'applications/GSP/layouts/MainLayout/components/Sidebar/constants';

import { useGetSchoolLogoUrl } from './hooks';

import type { FC } from 'react';

export const SCHOOL_LOGO_TEST_ID = 'school-logo';

export const SchoolLogo: FC = () => {
  const { t } = useTranslation();
  const logoUrl = useGetSchoolLogoUrl();

  return (
    <img
      data-testid={SCHOOL_LOGO_TEST_ID}
      src={logoUrl}
      width="100%"
      style={{ maxHeight: SCHOOL_LOGO_MAX_HEIGHT }}
      alt={t('GSP.features.schoolLogo.alt')}
    />
  );
};
